import React, { Component } from "react";
import PropTypes from "prop-types";
import Row from "../../shared_modules/common/grid/Row";
import Col from "../../shared_modules/common/grid/Col";
import ValidationMsg from "../../shared_modules/common/forms/ValidationMsg";

class Disclosure extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showTCModal: false,
      showETDModal: false,
      currentOpenModal: "none",
      disclosureStatus: "",
      msgData: {
        errors: {},
        info: {},
      },
    };

    this.state.msgData.errors[props.disclosureType] = {};
    this.state.msgData.info[props.disclosureType] = {};
  }

  static pI1ErrrorMessages = {
    esign: "You must agree to the E-Sign Consent to continue.",
    creditauth:
      "You must agree to the Application Terms & Conditions to continue.",
    privpolicy:
      "You must agree to the Credit Profile Authorization and Privacy Policy to continue.",
  };

  static defaultProps = {
    content: [
      { text: "I consent to the " },
      { type: "a", text: "Electronic Transactions & Disclosures", name: "etd" },
    ],
    disclosureType: "esign",
    isRequired: false,
    classes: {
      label: "label",
      field: "field",
      validation: "messaging",
    },
    colLayout: {
      1: { sm: 12, lg: 3 },
      2: { sm: 12, lg: 7 },
    },
  };

  initMsgObj = (disclosureType) => {
    const msgData = {
      errors: {},
      info: {},
    };

    msgData.errors[disclosureType] = {};
    msgData.info[disclosureType] = {};

    return msgData;
  };

  generateMessage = (msgType, disclosureType, id) => {
    let msgData = this.initMsgObj(disclosureType);

    if (msgType === "info") {
      msgData.info[disclosureType] = {
        type: msgType,
        slug: disclosureType,
        id: id,
        msg: "check the esign box.",
      };
    } else if (msgType === "error") {
      msgData.errors[disclosureType] = {
        type: msgType,
        msg: Disclosure.pI1ErrrorMessages[disclosureType],
        id: id,
        slug: disclosureType,
      };
    }

    return msgData;
  };

  handleChange = (ev) => {
    const chk = ev.target.checked,
      elementName = ev.target.name,
      { isRequired, onEventCallback, fieldMetadata } = this.props;

    let msgData = this.initMsgObj(elementName);

    fieldMetadata.isValid = chk;
    fieldMetadata.value = chk;
    if (!chk && isRequired) {
      msgData = this.generateMessage("error", elementName, ev.target.id);
      fieldMetadata.status = "invalid";
    } else {
      fieldMetadata.status = "";
    }

    this.setState({
      msgData,
    });

    if (onEventCallback && typeof onEventCallback === "function") {
      onEventCallback(ev, fieldMetadata);
    }
  };

  render() {
    const { colLayout, classes, disclosureType, content, fieldMetadata } =
        this.props,
      prefix = "pf-consent-",
      id = prefix + disclosureType;

    let { msgData } = this.state;
    if (fieldMetadata.status === "invalid") {
      msgData = this.generateMessage("error", disclosureType, id);
    }

    return (
      <Row
        key={disclosureType}
        className={`disclosure disclosure-${disclosureType}`}
      >
        <Col className="sm-collapse" width={colLayout[1]} />
        <Col className={classes.field} width={colLayout[2]}>
          <div className={`disclosure disclosure-${disclosureType}-message`}>
            <ValidationMsg
              who={id}
              filterFields={[disclosureType]}
              msgs={msgData}
            />
          </div>
          <div className="checkbox-group">
            <input
              id={id}
              name={disclosureType}
              type="checkbox"
              checked={fieldMetadata.value}
              className={fieldMetadata.status}
              onChange={this.handleChange}
            />
            <label htmlFor={id}>
              {content.map((sec, idx) => {
                if (sec.type === "a") {
                  return (
                    <a key={idx} href={sec.href} target={sec.target}>
                      {sec.text}
                    </a>
                  );
                }

                return <span key={idx}>{sec.text}</span>;
              })}
            </label>
          </div>
        </Col>
      </Row>
    );
  }
}

Disclosure.propTypes = {
  userType: PropTypes.string,
  colLayout: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  disclosureType: PropTypes.string.isRequired,
  isRequired: PropTypes.bool.isRequired,
  content: PropTypes.array.isRequired,
  onEventCallback: PropTypes.func.isRequired,
  fieldMetadata: PropTypes.object.isRequired,
};

export default Disclosure;

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');